import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import moment from 'moment';
import { Moment } from 'moment';
import { map } from 'rxjs/operators';

export interface Timerange {
  start: Moment;
  end: Moment;
}
export interface DataArchive {
  archive: {};
}
export interface ArchiveApiResponse {
  dtg: string;
  type: string;
  location: number;
  productId: number;
  customerId: number;
  path: string;
}

@Injectable({
  providedIn: 'root',
})
export class ArchiveService {
  private http = inject(HttpClient);

  private url = environment.url.bff + '/archive/';
  /*private dataUrl = environment.url.dataArchive.replace('https://', ''); // URL for requesting PDF's*/
  private dataUrl = environment.url.dataArchive; // URL for requesting PDF's

  public getPdfsFromApi(
    yearMonth: string,
    productsArchive: Array<{ id: string; productType: string }>
  ) {
    const url =
      environment.url.dataArchive + '/archive-pdf-' + yearMonth + '.json';
    return this.http.get<DataArchive>(url).pipe(
      map(data => {
        const mappedData = { archive: {} };
        for (const products of productsArchive) {
          if (!data.archive.hasOwnProperty(products.productType)) {
            continue;
          }
          /*TODO: anstatt isNullOrUndefined() check mit .hasOwnProperty*/
          if (!mappedData.archive.hasOwnProperty(products.productType)) {
            mappedData.archive[products.productType] = {};
          }
          mappedData.archive[products.productType][products.id] = [];
          if (!data.archive[products.productType].hasOwnProperty(products.id)) {
            // console.error('ERROR: Es FEHLEN Daten im ARCHIVE für:', products.productType, 'ID:', products.id, 'In der Datei:', yearMonth);
            continue;
          }
          for (const urlS3 of data.archive[products.productType][products.id]) {
            if (urlS3.length === 0) {
              continue;
            }
            const urlMetops = urlS3.replace(
              's3-eu-west-1.amazonaws.com/pdf.pipeline.wm/',
              this.dataUrl + '/'
            );
            mappedData.archive[products.productType][products.id].push(
              urlMetops
            );
          }
        }
        return mappedData;
      })
    );
  }

  getCustomerDocumentOfCustomer(customerId) {
    return this.http.get(this.url + customerId).pipe(
      map(data => {
        // const data = response.json();
        return data;
      })
    );
  }

  getArchiveTimeRangesForProduct(product: any): Timerange[] {
    if (
      product.saison === null &&
      product.contractExpiryDtg !== null &&
      product.contractExpiryDtg !== undefined
    ) {
      const timeRange = {
        start: moment(product.contractStartDtg, 'YYYYMMDD'),
        end: moment(product.contractExpiryDtg, 'YYYYMMDD'),
      };
      return [timeRange];
    } else if (
      product.saison !== null &&
      product.contractExpiryDtg !== null &&
      product.contractExpiryDtg !== undefined
    ) {
      const startYear = moment(product.contractStartDtg).year();
      const endYear = moment(product.contractExpiryDtg).year();
      const timeRanges: Timerange[] = [];
      for (let year = startYear; year <= endYear; year++) {
        const yearSeasonEnd =
          Number(product.saison.start.month) <= Number(product.saison.end.month)
            ? year
            : year + 1;
        const seasonOfYear: Timerange = {
          start: moment({
            year: year,
            month: Number(product.saison.start.month) - 1,
            day: Number(product.saison.start.day),
          }),
          end: moment({
            year: yearSeasonEnd,
            month: Number(product.saison.end.month) - 1,
            day: Number(product.saison.end.day),
          }),
        };
        timeRanges.push(seasonOfYear);
        if (endYear === yearSeasonEnd) {
          break;
        }
      }
      return timeRanges;
    } else if (
      product.saison !== null &&
      (product.contractExpiryDtg === null ||
        product.contractExpiryDtg === undefined)
    ) {
      const startYear = moment(product.contractStartDtg).year();
      const endYear = moment().year();
      const timeRanges: Timerange[] = [];
      for (let year = startYear; year <= endYear; year++) {
        const yearSeasonEnd =
          Number(product.saison.start.month) <= Number(product.saison.end.month)
            ? year
            : year + 1;
        const seasonOfYear: Timerange = {
          start: moment({
            year: year,
            month: Number(product.saison.start.month) - 1,
            day: Number(product.saison.start.day),
          }),
          end: moment({
            year: yearSeasonEnd,
            month: Number(product.saison.end.month) - 1,
            day: Number(product.saison.end.day),
          }),
        };
        timeRanges.push(seasonOfYear);
        if (endYear === yearSeasonEnd) {
          break;
        }
      }
      return timeRanges;
    }
    return null;
  }

  /*=======================================================*/

  getProductData(
    productType: string,
    customerId: number,
    productId: number,
    dtgStart: string,
    dtgEnd: string
  ) {
    // dtgStart & dtgEnd Format --> 2021-02-17T13:00:00Z
    const url =
      this.url +
      productType +
      `?customerId=${customerId}&productId=${productId}&dtgStart=${dtgStart}&dtgEnd=${dtgEnd}`;

    return this.http.get<ArchiveApiResponse[]>(url);
  }

  buildPdfUrl(pathOfPdf: string): string {
    return this.dataUrl + '/' + pathOfPdf;
  }
}
